<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false">
    <el-form ref="editForm" :model="record" label-width="100px" :rules="validateRules">
      <el-form-item label="年月" prop="month">
        <el-date-picker type="month" v-model="record.month" value-format="yyyyMM"></el-date-picker>
      </el-form-item>
      <el-form-item label="生成数量" prop="month">
        <el-input-number type="number" v-model="record.serialCount" :min="1"></el-input-number>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button type="default" @click="close">取消</el-button>
      <el-button type="primary" @click="save" icon="fa fa-save" :loading="loading">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";

export default {
  name: 'DeviceSerialEdit',
  extends: BaseVue,
  props: {
    record: {
      require: true
    }
  },
  data() {
    return {
      validateRules: {
        month: [{required: true, trigger:'blur', message:'年月'}],
        serialCount: [{required: true, trigger:'blur', message:'设备编号生成数量不能为空'}]
      }
    }
  },
  created() {
  },
  methods: {
    save() {
      let editForm = this.$refs["editForm"];
      editForm.validate((yes)=>{
        if(yes){
          this.loading = true;
          this.postForm("/device-serials/saveSerials", this.record, true).then(dr=>{
            this.$emit("save", dr.bean);
          }).finally(()=>{
            this.loading = false;
          });
        }
      })
    },
    close() {
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
</style>